export const elzbietaKuleszko = {
    'meta': {
        'title': 'Psychoterapeuta, psychotraumatolog Elżbieta Kuleszko',
        'description': 'Psychoterapeuta w paradygmacie psychodynamicznym, Terapeuta EMDR. Pracuje z dorosłymi, dziećmi, młodzieżą i rodzinami.'
    },
    'url': {
        'address': '/torun/zespol/psycholog-psychoterapeuta-psychotraumatolog-elzbieta-kuleszko/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/elzbieta-kuleszko.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog w Toruniu, Psychoterapeuta w Toruniu Elżbieta Kuleszko, Psychotraumatolog w Toruniu Elżbieta Kuleszko'
        }
    }
}